import React, { useCallback } from 'react'
import { XIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { Button } from '@/shared/components/ui/button'

export function RemoveCombinationButton({ id }: { id: string }) {
	const { setValue, watch } = useFormContext()

	const handleDeleteGlobalSet = useCallback(
		(ids: string) =>
			setValue(
				'globalSetIds',
				watch('globalSetIds')?.filter(
					(globalSetId: string) => globalSetId !== ids
				)
			),
		[id]
	)

	return (
		<Button
			variant='outline'
			size='icon-sm'
			onClick={() => handleDeleteGlobalSet(id)}
		>
			<XIcon />
		</Button>
	)
}
